import React from 'react';
import { ReachButton } from '../ReachButton/ReachButton';
import { processLink } from '../../shared/processLink';

export interface ICustomButton {
    field_button_icon_select?: string;
    field_button_style?: string;
    field_icon_alignment: string;
    field_custom_button_link?: ICustomButtonLinks;
}

interface ICustomButtonLinks {
    title: string;
    uri: string;
}

export const CustomButton = (props: ICustomButton) => {
    if (!props.field_custom_button_link) {
        return null;
    }

    enum ButtonIconSelect {
        user = `ki-person`,
        right_arrow = `ki-arrow-right`,
        left_arrow = `ki-arrow-left`,
        download = `ki-download`,
        play_media = `ki-play-f`,
        undefined = `none`,
    }

    enum CustomButtonStyle {
        primary = `primary`,
        secondary = `secondary`,
        borderless = `borderless`,
    }

    enum IconAlignment {
        left = `left`,
        right = `right`,
    }

    const customStyle =
        CustomButtonStyle[props.field_button_style] ??
        CustomButtonStyle.primary;

    const customIcon = ButtonIconSelect[props.field_button_icon_select];

    if (customIcon) {
        return (
            <ReachButton
                buttonStyle={customStyle}
                buttonIcon={{
                    icon: customIcon,
                    position: IconAlignment[props.field_icon_alignment],
                }}
                href={processLink(props.field_custom_button_link?.uri)}
            >
                {props.field_custom_button_link?.title}
            </ReachButton>
        );
    } else {
        return (
            <ReachButton
                buttonStyle={customStyle}
                href={processLink(props.field_custom_button_link?.uri)}
            >
                {props.field_custom_button_link?.title}
            </ReachButton>
        );
    }
};
